import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';

const DefaultLayoutOverride = fr.metaOverride({ base: BaseOverride });

export default DefaultLayoutOverride;
